export default __webpack_public_path__ + "static/media/5.626b2e17.jpg";